package org.hs_soft.runmynesto.domain.model.home.home.data_assistant_logs


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class DataAssistantLogsModel(
    val message: String?,
    val answer: String?,
    @SerialName("is_generating")
    val isGenerating: Boolean?,
    @SerialName("audio_url")
    val audioUrl: String?
)